import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { landingRoute } from '~/utils/constants/routes';
import { AnimatedSection, SEO } from '~/components/common';
import { contactEmail } from '~/utils/constants/env';

const CookiePolicy: React.FC = () => {
  //#region Declare Hook
  const { t } = useTranslation();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <div className='min-h-screen bg-lumi-dark-300 text-white'>
      <SEO type='cookiePolicy' />
      <section className='pt-32 pb-24 px-4 sm:px-6 lg:px-8'>
        <div className='max-w-3xl mx-auto'>
          <AnimatedSection animation='fade-in'>
            <Link to={landingRoute.home} className='inline-flex items-center gap-2 text-white/40 hover:text-white text-sm mb-10 transition-colors'>
              <svg className='w-4 h-4' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15 19l-7-7 7-7' />
              </svg>
              {t('common.backToHome')}
            </Link>

            <h1 className='text-4xl font-bold text-white mb-4'>{t('cookiePolicy.title')}</h1>
            <p className='text-white/40 text-sm mb-10'>{t('cookiePolicy.lastUpdated')}</p>
            <p className='text-white/60 leading-relaxed mb-10'>{t('cookiePolicy.intro')}</p>
          </AnimatedSection>

          <div className='space-y-10'>
            {(['section1', 'section2', 'section3', 'section4', 'section5', 'section6'] as const).map((key, index) => (
              <AnimatedSection key={key} animation='slide-up' delay={index * 60} className='border-t border-white/10 pt-8'>
                <h2 className='text-xl font-semibold text-white mb-4'>{t(`cookiePolicy.${key}.title`)}</h2>
                <p className='text-white/60 leading-relaxed'>{t(`cookiePolicy.${key}.content`, { contactEmail: contactEmail })}</p>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;
